import React, { useMemo, useState } from 'react';
import './App.css';
import "react-image-gallery/styles/css/image-gallery.css";

const FRAME_OPTIONS = [
  { value: 'black', label: 'Fekete' },
  { value: 'white', label: 'Fehér' },
];

const TYPE_OPTIONS = [
  { value: 'Marvel', label: 'Marvel' },
  { value: 'DC', label: 'DC' },
  { value: 'Star Wars', label: 'Star Wars' },
  { value: 'Harry Potter', label: 'Harry Potter' },
  { value: 'eskuvo', label: 'Esküvő' },
  { value: 'szulinap', label: 'Szülinap' },
];

const BASE_SIZES = [2, 4, 5, 6, 8, 10];
const BASE_SIZES_WithPrices = [
  { size: 2, price: 10990 },
  { size: 4, price: 12990 },
  { size: 5, price: 14990 },
  { size: 6, price: 15990 },
  { size: 8, price: 17990 },
  { size: 10, price: 19990 },
];

const shippingTypes = [
  { type: 'Foxpost boxba', price: 1900 },
  { type: 'Foxpost házhoz', price: 2600 },
  { type: 'GLS házhoz', price: 2790 },
];

function App() {
  const [frame, setFrame] = useState('black');
  const [type, setType] = useState('Marvel');
  const [size, setSize] = useState(2);
  const [birthdayNumber, setBirthdayNumber] = useState('');
  const [shippingMethod, setShippingMethod] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [foxpostPointName, setFoxpostPointName] = useState('');
  const [foxpostPointAddress, setFoxpostPointAddress] = useState('');
  const [topGreeting, setTopGreeting] = useState('');

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [message, setMessage] = useState('');

  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);

  const [galleryModalIndex, setGalleryModalIndex] = useState(null);
  const [characters, setCharacters] = useState([]);
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [characterTraits, setCharacterTraits] = useState([]);
  const [selectedCharacterTraits, setSelectedCharacterTraits] = useState([]);

  const defaultImages = [
    {
      original: "/img/igazihos5.jpg",
      thumbnail: "/img/igazihos5.jpg",
    },
    {
      original: "/img/igazihos9.jpg",
      thumbnail: "/img/igazihos9.jpg",
    },
    {
      original: "/img/igazihos10.jpg",
      thumbnail: "/img/igazihos10.jpg",
    },
    {
      original: "/img/igazihos14.jpg",
      thumbnail: "/img/igazihos14.jpg",
    },
    {
      original: "/img/igazihos6.jpg",
      thumbnail: "/img/igazihos6.jpg",
    },
    {
      original: "/img/igazihos11.jpg",
      thumbnail: "/img/igazihos11.jpg",
    },
    {
      original: "/img/igazihos12.jpg",
      thumbnail: "/img/igazihos12.jpg",
    },
    {
      original: "/img/igazihos13.jpg",
      thumbnail: "/img/igazihos13.jpg",
    },
    {
      original: "/img/igazihos15.jpg",
      thumbnail: "/img/igazihos15.jpg",
    },
    // {
    //   original: "/img/igazihos1.jpg",
    //   thumbnail: "/img/igazihos1.jpg",
    // },
    // {
    //   original: "/img/igazihos2.jpg",
    //   thumbnail: "/img/igazihos2.jpg",
    // },
    // {
    //   original: "/img/igazihos3.jpg",
    //   thumbnail: "/img/igazihos3.jpg",
    // },
    {
      original: "/img/igazihos4.jpg",
      thumbnail: "/img/igazihos4.jpg",
    },
    {
      original: "/img/igazihos8.jpg",
      thumbnail: "/img/igazihos8.jpg",
    },
    {
      original: "/img/igazihos7.jpg",
      thumbnail: "/img/igazihos7.jpg",
    },
  ];

  const [images, setImages] = useState(defaultImages);

  const effectiveSizes = useMemo(() => {
    if (type === 'eskuvo') return [2];
    else if (type === 'szulinap') return [2];
    else if (type === 'Star Wars') return [5, 8];
    else return [2, 4, 6, 8, 10];
  }, [type, birthdayNumber]);

  // Keep size in sync with special rules
  React.useEffect(() => {
    if (type === 'eskuvo') {
      setSize(2);
    } else if (type === 'szulinap') {
      setSize(2);
    } else if (!effectiveSizes.includes(size)) {
      setSize(effectiveSizes[0]);
    }

    fetch("/characters.json")
      .then((res) => res.json())
      .then((data) => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name, 'hu'));
        setCharacters(sorted);
      });

    fetch("/charactertraits.json")
      .then((res) => res.json())
      .then((data) => {
        setCharacterTraits(data)
      });
  }, [type, birthdayNumber, effectiveSizes, size]);

  const errors = useMemo(() => {
    const currentErrors = {};
    if (!name.trim()) currentErrors.name = 'Kötelező mező';
    if (!phone.trim()) currentErrors.phone = 'Kötelező mező';
    if (!email.trim()) currentErrors.email = 'Kötelező mező';
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) currentErrors.email = 'Érvénytelen email';
    if (!address.trim()) currentErrors.address = 'Kötelező mező';
    if (!topGreeting.trim()) currentErrors.topGreeting = 'Kötelező mező';
    if (shippingMethod === 'Foxpost boxba') {
      if (!foxpostPointName.trim()) currentErrors.foxpostPointName = 'Kötelező mező';
      if (!foxpostPointAddress.trim()) currentErrors.foxpostPointAddress = 'Kötelező mező';
    }
    if (type === 'szulinap') {
      const digits = String(birthdayNumber).replace(/\D/g, '');
      if (!digits) currentErrors.birthdayNumber = 'Add meg a születésnap számát';
      else if (parseInt(digits, 10) <= 0 || parseInt(digits, 10) > 120) currentErrors.birthdayNumber = '0-120 között add meg';
    }
    return currentErrors;
  }, [name, phone, email, address, topGreeting, shippingMethod, foxpostPointName, foxpostPointAddress, type, birthdayNumber]);

  function markTouched(field) {
    setTouched(prev => ({ ...prev, [field]: true }));
  }

  function handleShippingChange(value) {
    setShippingMethod(value);
    if (value !== 'Foxpost boxba') {
      setFoxpostPointName('');
      setFoxpostPointAddress('');
      setTouched(prev => {
        const next = { ...prev };
        delete next.foxpostPointName;
        delete next.foxpostPointAddress;
        return next;
      });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
    if (Object.keys(errors).length > 0) return;
    // Simulate submit
    var birthdayNumberFinal = parseInt(birthdayNumber);
    fetch("https://www.azigazihos.hu/api/submitorder", {
    //fetch("https://localhost:7085/api/submitorder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        frame,
        type,
        size,
        birthdayNumberFinal,
        shippingMethod,
        paymentMethod,
        topGreeting,
        foxpostPointName,
        foxpostPointAddress,
        name,
        phone,
        email,
        address,
        message,
        selectedCharacters,
        selectedCharacterTraits
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Hiba a rendelés elküldésekor");
          return res.text();
      })
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        alert("Hiba történt a rendelés elküldésekor. Próbáld újra később vagy írj nekünk emailt.");
      });
  }

  return (
    <div className="container py-4">
      <header className="mb-4">
        <nav className="navbar navbar-expand-lg navbar-light bg-light rounded mb-3 px-3 shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>
          <a className="navbar-brand d-flex align-items-center" href="#home" style={{ fontWeight: "bold", fontSize: "1.5rem", color: "#2c3e50" }}>
            <img src="img/logo.jpg" alt="" width="48" height="48" style={{ borderRadius: "16px", marginRight: "12px" }} />
            Az Igazi HŐS
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            aria-controls="mainNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link" href="#home" onClick={e => { e.preventDefault(); document.getElementById('home').scrollIntoView({ behavior: 'smooth' }); }} style={{ color: "#555", fontWeight: "500" }}>Főoldal</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#testimonials" onClick={e => { e.preventDefault(); document.getElementById('testimonials').scrollIntoView({ behavior: 'smooth' }); }} style={{ color: "#555", fontWeight: "500" }}>Vásárlóink mondták</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact" onClick={e => { e.preventDefault(); document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }); }} style={{ color: "#555", fontWeight: "500" }}>Kapcsolat</a>
              </li>
            </ul>
          </div>
        </nav>
        
      </header>

      
      {(() => {
        
        return (
          <div id="home">
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-2 justify-content-center align-items-center">
              {images.slice(0, 4).map((img, idx) => (
          <div className="col" key={idx}>
            <img
              src={img.original}
              alt={img.originalAlt || ""}
              className="img-fluid rounded shadow-sm gallery-thumb"
              style={{ cursor: "pointer", objectFit: "cover", height: "300px" }}
              onClick={() => setGalleryModalIndex(idx)}
            />
          </div>
              ))}
            </div>
            {/* Modal for gallery */}
            {typeof galleryModalIndex === "number" && (
              <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.7)" }}
          tabIndex="-1"
          role="dialog"
          onClick={() => setGalleryModalIndex(null)}
              >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content bg-dark text-white">
              <div className="modal-header border-0">
                <button
            type="button"
            className="btn-close btn-close-white ms-auto"
            aria-label="Close"
            onClick={() => setGalleryModalIndex(null)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <img
            src={images[galleryModalIndex].original}
            alt={images[galleryModalIndex].originalAlt || ""}
            className="img-fluid rounded"
            style={{ maxHeight: "70vh" }}
                />
              </div>
              <div className="modal-footer justify-content-between border-0">
                <button
            className="btn btn-outline-light"
            disabled={galleryModalIndex === 0}
            onClick={() => setGalleryModalIndex(i => i - 1)}
                >
            Előző
                </button>
                <span>
            {galleryModalIndex + 1} / {images.length}
                </span>
                <button
            className="btn btn-outline-light"
            disabled={galleryModalIndex === images.length - 1}
            onClick={() => setGalleryModalIndex(i => i + 1)}
                >
            Következő
                </button>
              </div>
            </div>
          </div>
              </div>
            )}
          </div>
        );
      })()}
      
      <section id="testimonials" className="my-5">
        <div style={{marginTop: "20px"}}>
          <div className="card">
            <div className="card-body p-5">
              <h2>Egy igazán különleges, kreatív ajándékot keresel? Valamit, ami garantáltan mosolyt csal az arcokra - gyerekeknek, felnőtteknek, igazi szuperhősöknek?</h2>
              <ul>
                <li>Egyedi ajándékboxainkat szuperhős figurákkal, személyre szabott névvel és üzenettel készítjük el</li>
                <li>Tökéletes ajándék születésnapra, ballagásra, évfordulóra, apák napjára, pedagógusnak, vagy „csak úgy" szeretetből</li>
                <li>Marvel és DC hősök egyaránt megtalálhatók: Pókember, Vasember, Thor, Batman, Superman, Deadpool és még sokan mások</li>
                <li>Kézműves minőség, szívvel-lélekkel készítve</li>
              </ul>
              <p>Minden ajándékbox személyre szabható - nálunk Te vagy az Igazi HŐS!</p>
              <p>Rendelés, ötletelés vagy inspiráció:</p>
              <a href="https://www.facebook.com/profile.php?id=100072244148621" target='_blank'>Az Igazi HŐS Facebook oldalunkon</a>
            </div>
          </div>
        </div>
        <div style={{marginTop:"50px"}}>
          <h2 className="h4 mb-4">Vásárlóink mondták</h2>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <p className="card-text">"Szupergyors és kedves 'kiszolgálás' (szinte azonnali email váltások 🙂 és gyors szállítás) és egy minőségi, ötletes termék - a legjobb kombináció! Emlékezetes marad az Apák Napja - köszönjük!""</p>
                  <div className="text-end text-muted small">R. Dóra</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <p className="card-text">"Profizmus jellemzi őket. Maximálisan nyitottak az egyedi igényekre (látványterv küldése). A termék a várakozásomat is felülmúlta, gondos csomagolás igényes szép kidolgozás. Csak ajánlani tudom őket!"</p>
                  <div className="text-end text-muted small">V. Kata</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <p className="card-text">"Eddig kedves, segítőkész, korrekt és rugalmas csapatot ismerhettem meg! Így nagy bizalommal vagyok az érkező csomag iránt! Ajánlom mindenkinek aki ötletes ajándékot szeretne! 🙂"</p>
                  <div className="text-end text-muted small">K. Emese</div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>

      {success ? (
        <div className="alert alert-success" role="alert">
          Köszönjük! A rendelés adatait rögzítettük. Hamarosan felvesszük veled a kapcsolatot.
        </div>
      ) : (
        <form onSubmit={handleSubmit} noValidate>
          <div className="row g-4">
            <div className="col-12 col-lg-6">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="h5 mb-3">1) Termék konfigurálása</h2>

                  <div className="mb-3">
                    <label className="form-label">Keret</label>
                    <div className="d-flex gap-2 flex-wrap">
                      {FRAME_OPTIONS.map(opt => (
                        <button
                          key={opt.value}
                          type="button"
                          className={`btn btn-outline-secondary ${frame === opt.value ? 'active' : ''}`}
                          onClick={() => setFrame(opt.value)}
                          aria-pressed={frame === opt.value}
                        >
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="type" className="form-label">Típus</label>
                    <select
                      id="type"
                      className="form-select"
                      value={type}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setType(newType);
                        setSelectedCharacters([]);
                        setSelectedCharacterTraits([]);
                        setBirthdayNumber('');
                        setSize(2);
                      }}
                    >
                      {TYPE_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  {type === 'szulinap' && (
                    <div className="mb-3">
                      <label htmlFor="birthdayNumber" className="form-label">Születésnap száma</label>
                      <input
                        type="number"
                        inputMode="numeric"
                        min={1}
                        max={120}
                        id="birthdayNumber"
                        className={`form-control ${submitted || touched.birthdayNumber ? (errors.birthdayNumber ? 'is-invalid' : 'is-valid') : ''}`}
                        value={birthdayNumber}
                        onBlur={() => markTouched('birthdayNumber')}
                        onChange={(e) => setBirthdayNumber(e.target.value)}
                        placeholder="Pl. 30"
                        required
                      />
                      <div className="invalid-feedback">{errors.birthdayNumber}</div>
                    </div>
                  )}

                  {type !== 'szulinap' && (
                    <div className="mb-3">
                      <label htmlFor="size" className="form-label">Méret</label>
                      <select
                        id="size"
                        className="form-select"
                        value={size}
                        onChange={(e) => setSize(parseInt(e.target.value, 10))}
                        disabled={type === 'eskuvo' || type === 'szulinap'}
                      >
                        {effectiveSizes.map(s => {
                          const item = BASE_SIZES_WithPrices.find(p => p.size === s);
                          return (
                            <option key={s} value={s}>
                              {s} darabos {item ? `- ${item.price} Ft` : ""}
                            </option>
                          );
                        })}
                      </select>
                      {type === 'eskuvo' && <small className="text-muted">Esküvő típusnál a méret fixen 2 darabos.</small>}
                    </div>
                  )}
                  
                  {size && effectiveSizes.includes(size) && type != 'eskuvo' && type != 'szulinap' && (
                    <div className="mb-3">
                      <label className="form-label">Karakterek</label>
                      {[...Array(size)].map((_, idx) => {
                        // Get all selected character ids except the current one
                        const selectedExceptCurrent = selectedCharacters.filter((_, i) => i !== idx);
                        return (
                          <div className="d-flex align-items-center mb-2" key={idx}>
                            <select
                              className="form-select me-2"
                              style={{ minWidth: 180 }}
                              value={selectedCharacters[idx] || ''}
                              onChange={e => {
                                const updated = [...selectedCharacters];
                                updated[idx] = e.target.value;
                                setSelectedCharacters(updated);

                                // Reset trait if character changes
                                const updatedTraits = [...selectedCharacterTraits];
                                updatedTraits[idx] = '';
                                setSelectedCharacterTraits(updatedTraits);
                              }}
                              required
                            >
                              <option value="">Válassz karaktert...</option>
                              {characters
                                .filter(char => char.universe === type)
                                .filter(char => {
                                  // Only show if not already selected elsewhere, or is the current selection
                                  const charId = char.id || char.name;
                                  return (
                                    !selectedExceptCurrent.includes(charId) ||
                                    selectedCharacters[idx] === charId
                                  );
                                })
                                .map(char => (
                                  <option key={char.id || char.name} value={char.id || char.name}>
                                    {char.name}
                                  </option>
                                ))}
                            </select>
                            {selectedCharacters[idx] && (
                              <select
                                className="form-select"
                                style={{ minWidth: 180 }}
                                value={selectedCharacterTraits[idx] || ''}
                                onChange={e => {
                                  const updated = [...selectedCharacterTraits];
                                  updated[idx] = e.target.value;
                                  setSelectedCharacterTraits(updated);
                                }}
                                required
                              >
                                <option value="">Válassz jellemvonást...</option>
                                {(
                                  characterTraits.find(c => c.name === selectedCharacters[idx])?.charactertraits || []
                                ).map(trait => (
                                  <option key={trait} value={trait}>
                                    {trait}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">Szállítás</label>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="shipping" id="FoxpostBox" value="Foxpost boxba" checked={shippingMethod === 'Foxpost boxba'} onChange={(e) => handleShippingChange(e.target.value)} />
                      <label className="form-check-label" htmlFor="FoxpostBox">
                        Foxpost boxba - 1 900 Ft
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="shipping" id="FoxpostDoor" value="Foxpost házhoz" checked={shippingMethod === 'Foxpost házhoz'} onChange={(e) => handleShippingChange(e.target.value)} />
                      <label className="form-check-label" htmlFor="FoxpostDoor">
                        Foxpost házhoz - 2 600 Ft
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="shipping" id="gls" value="GLS házhoz" checked={shippingMethod === 'GLS házhoz'} onChange={(e) => handleShippingChange(e.target.value)} />
                      <label className="form-check-label" htmlFor="gls">
                        GLS házhoz - 2 790 Ft
                      </label>
                    </div>

                    {shippingMethod === 'Foxpost boxba' && (
                      <div className="mt-3">
                        <div className="mb-3">
                          <label htmlFor="foxpostPointName" className="form-label">Foxpost csomagpont neve</label>
                          <input
                            id="foxpostPointName"
                            className={`form-control ${submitted || touched.foxpostPointName ? (errors.foxpostPointName ? 'is-invalid' : 'is-valid') : ''}`}
                            value={foxpostPointName}
                            onBlur={() => markTouched('foxpostPointName')}
                            onChange={(e) => setFoxpostPointName(e.target.value)}
                            placeholder="Pl. Allee csomagautomata"
                            required
                          />
                          <div className="invalid-feedback">{errors.foxpostPointName}</div>
                        </div>
                        <div className="mb-0">
                          <label htmlFor="foxpostPointAddress" className="form-label">Foxpost csomagpont címe</label>
                          <textarea
                            id="foxpostPointAddress"
                            rows={2}
                            className={`form-control ${submitted || touched.foxpostPointAddress ? (errors.foxpostPointAddress ? 'is-invalid' : 'is-valid') : ''}`}
                            value={foxpostPointAddress}
                            onBlur={() => markTouched('foxpostPointAddress')}
                            onChange={(e) => setFoxpostPointAddress(e.target.value)}
                            placeholder="Pl. 1117 Budapest, Október huszonharmadika utca 8-10."
                            required
                          />
                          <div className="invalid-feedback">{errors.foxpostPointAddress}</div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Fizetés</label>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="payment" id="utalas" value="Előre utalás" checked={paymentMethod === 'Előre utalás'} onChange={(e) => setPaymentMethod(e.target.value)} />
                      <label className="form-check-label" htmlFor="utalas">
                        Előre utalás - ingyenes
                      </label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="payment" id="utanvet" value="Utánvét" checked={paymentMethod === 'Utánvét'} onChange={(e) => setPaymentMethod(e.target.value)} />
                      <label className="form-check-label" htmlFor="utanvet">
                        Utánvét - 600 Ft
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="h5 mb-3">2) Személyes adatok</h2>

                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Név</label>
                    <input
                      id="name"
                      className={`form-control ${submitted || touched.name ? (errors.name ? 'is-invalid' : 'is-valid') : ''}`}
                      value={name}
                      onBlur={() => markTouched('name')}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                    <div className="invalid-feedback">{errors.name}</div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Telefonszám</label>
                    <input
                      id="phone"
                      className={`form-control ${submitted || touched.phone ? (errors.phone ? 'is-invalid' : 'is-valid') : ''}`}
                      value={phone}
                      onBlur={() => markTouched('phone')}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="+36 ..."
                      required
                    />
                    <div className="invalid-feedback">{errors.phone}</div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      id="email"
                      className={`form-control ${submitted || touched.email ? (errors.email ? 'is-invalid' : 'is-valid') : ''}`}
                      value={email}
                      onBlur={() => markTouched('email')}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <div className="invalid-feedback">{errors.email}</div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="topGreeting" className="form-label">Megszólítás a kép tetején? (Apa, Papa, stb.)</label>
                    <input
                      id="topGreeting"
                      className={`form-control ${submitted || touched.topGreeting ? (errors.topGreeting ? 'is-invalid' : 'is-valid') : ''}`}
                      value={topGreeting}
                      onBlur={() => markTouched('topGreeting')}
                      onChange={(e) => setTopGreeting(e.target.value)}
                      placeholder="Pl. Apa"
                      required
                    />
                    <div className="invalid-feedback">{errors.topGreeting}</div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">Cím</label>
                    <textarea
                      id="address"
                      rows={3}
                      className={`form-control ${submitted || touched.address ? (errors.address ? 'is-invalid' : 'is-valid') : ''}`}
                      value={address}
                      onBlur={() => markTouched('address')}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                    />
                    <div className="invalid-feedback">{errors.address}</div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">Üzenet (opcionális)</label>
                    <textarea
                      id="message"
                      rows={3}
                      className="form-control"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>

                  <div className="border-top pt-3 d-flex flex-column gap-2">
                    <div className="small text-muted">
                      Összegzés: {FRAME_OPTIONS.find(f => f.value === frame)?.label} keret, {TYPE_OPTIONS.find(t => t.value === type)?.label} típus, {size} darabos, szállítás: {shippingMethod}.
                    </div>
                    <div>
                      Ár: {BASE_SIZES_WithPrices.find(p => p.size === size)?.price || '0'} Ft + szállítás: {shippingTypes.find(p => p.type === shippingMethod)?.price || '0'} Ft {paymentMethod == 'Utánvét' ? " + utánvét: 600 Ft" : ""}
                    </div>
                    <div>
                      Összesen: {(BASE_SIZES_WithPrices.find(p => p.size === size)?.price || 0) + (shippingTypes.find(p => p.type === shippingMethod)?.price || 0) + (paymentMethod === 'Utánvét' ? 600 : 0)} Ft
                    </div>
                    <button type="submit" className="btn btn-primary align-self-start">Rendelés elküldése</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      <section id="contact" className="my-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-md-center">
              <img src="/img/contact2.jpg" alt="Kapcsolat" style={{ width: "100%" }}/>
            </div>
            <div className="col-md-6 align-self-center" style={{ paddingLeft: "50px" }}>
              <p><strong>Elérhetőségeink:</strong></p>
              <br />
              <p>Facebook{" "}<a href="https://www.facebook.com/profile.php?id=100072244148621" target="_blank">Az Igazi HŐS</a>
              </p>
              <br />
              <p>E-mail:{" "}<a href="mailto:azigazihos@gmail.com">azigazihos@gmail.com</a></p>
              <br />
              <p>Telefonszám:{" "}<a href="tel:+36705933478" className="footerfontcolor">+36 70 593 34 78</a></p>
            </div>
          </div>
        </div>
      </section>

      <footer className="text-center text-muted mt-4 small">© {new Date().getFullYear()} Az Igazi Hős</footer>
    </div>
  );
}

export default App;
